export const dispatch = (x) => x.type;
export const dispatch2 = (a, b) => a.type + "-" + b.type;
